var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhotosNotFoundIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 293.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#e8e8e8;stroke-miterlimit:10;stroke-width:7px;}.cls-1{stroke-linecap:round;}.cls-3{fill:#e8e8e8;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "photos-not-found-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_10",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 10"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 296.3,
    y1: 289.31,
    x2: 250.14,
    y2: 243.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 150,
    cy: 147.38,
    r: 138.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.39,192.48a52.37,52.37,0,0,1,97.22,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 104.17,
    cy: 116.35,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 195.83,
    cy: 116.35,
    r: 7.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotosNotFoundIcon);
export default __webpack_public_path__ + "static/media/photos-not-found-icon.169be32f970a5bc2725773b94f5e4422.svg";
export { ForwardRef as ReactComponent };